import { format } from "date-fns";
import { ja } from "date-fns/locale";

export function formatDateTime(dateTime) {
  if (typeof dateTime === "string") {
    dateTime = new Date(dateTime);
  }

  return format(dateTime, "yyyy年M月d日 (ccc) H:mm", {
    locale: ja,
  });
}
